import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchDispatch, fetchDetail } from '@/api/PMS/customerService/complaintManage';
import { userList } from '@/api/PMS/repair/repairManagement';
export default {
  props: ['keyValue', 'flowNum', 'showDialog'],
  data: function data() {
    return {
      propstree: {
        label: 'userTreeName',
        value: 'id',
        children: 'userList'
      },
      rules: {
        repairUserList: [{
          required: true,
          message: '请输入派工人员',
          trigger: 'blur'
        }],
        repairTime: [{
          required: true,
          message: '请选择派工时间',
          trigger: 'blur'
        }]
      },
      dialogImageUrl: '',
      dialogVisible: false,
      fileList: [],
      files: [],
      options: [],
      showPerson: true,
      childData: {},
      dispatchData: {}
    };
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.$refs.dataForm.resetFields();
        this.init();
      }
    }
  },
  created: function created() {
    this.uploadUrl = process.env.VUE_APP_UPLOAD;
    this.downloadUrl = process.env.VUE_APP_DOWNLOAD;
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;

      this.fileList = [];
      this.files = [];
      this.dispatchData = {};
      this.loadUserList();
      this.$nextTick(function () {
        _this.$refs['dataForm'].clearValidate();
      });

      if (this.keyValue > 0) {
        var queryData = {
          id: this.keyValue,
          flowNum: this.flowNum
        };
        fetchDetail(queryData).then(function (response) {
          _this.childData = response.data.data;
          _this.childData.fileMsgs && _this.childData.fileMsgs.forEach(function (item) {
            _this.fileList.push({
              name: item.fileName,
              url: item.fileId,
              fileId: item.fileId,
              fileName: item.fileName,
              fileUrl: item.fileId
            });
          });
          _this.files = _this.fileList;
        });
      } else {
        this.childData = {};
      }
    },
    loadUserList: function loadUserList() {
      var _this2 = this;

      userList().then(function (response) {
        _this2.options = response.data.data;
      });
    },
    trimStr: function trimStr(str, length) {
      if (str === null || str === '' || str === undefined) {
        return '';
      } else {
        if (str.length > length) {
          return str.substring(0, length) + '...';
        } else {
          return str;
        }
      }
    },
    tooltipDisabled: function tooltipDisabled(str, length) {
      if (str !== null) {
        if (str.length > length) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
    handleSuccess: function handleSuccess(response, file) {
      this.addList.push({
        fileId: file.response.data[0].fileId,
        fileName: response.data[0].fileName,
        fileType: this.judgeFileType(file.raw.type)
      });
      this.fileList.push({
        fileId: file.response.data[0].fileId,
        fileName: response.data[0].fileName,
        fileType: this.judgeFileType(file.raw.type)
      });
    },
    handleError: function handleError(err, file, fileList) {
      var res = JSON.parse(err.message);
      this.$message({
        message: res.message,
        type: 'error'
      });
    },
    handleExceed: function handleExceed() {},
    handlePreview: function handlePreview(file) {
      if (file.response) {
        // 当还未保存到业务逻辑中时的预览图片
        if (file.name.includes('png') || file.name.includes('jpg') || file.name.includes('jpeg')) {
          // 当附件是图片的时候在线打开
          this.dialogVisible = true;
          this.dialogImageUrl = this.downloadUrl + file.response.data[0].fileId;
        } else {
          // 当附件是文件的时候在线下载
          this.dialogImageUrl = this.downloadUrl + file.response.data[0].fileId;
          this.handleDownload(this.dialogImageUrl, file.name);
        }
      } else {
        // 当已保存到业务逻辑中时的预览图片
        if (file.name.includes('png') || file.name.includes('jpg') || file.name.includes('jpeg')) {
          // 当附件是图片的时候在线打开
          this.dialogVisible = true;
          this.dialogImageUrl = this.downloadUrl + file.url;
        } else {
          // 当附件是文件的时候在线下载
          this.dialogImageUrl = this.downloadUrl + file.url;
          this.handleDownload(this.dialogImageUrl, file.name);
        }
      }
    },
    // 移除图片之前做的操作
    beforeRemove: function beforeRemove(file, fileList) {// return this.$confirm(`确定移除 ${ file.name }？`)
    },
    beforeUpload: function beforeUpload(file) {
      var isLt2M = file.size / 1024 / 1024 < 10;

      if (!isLt2M) {
        this.$message({
          message: '上传大小不能超过 10MB!',
          type: 'error'
        });
        return false;
      }
    },
    // 移除图片
    handleRemove: function handleRemove(file, fileList) {
      var _this3 = this;

      console.log(file);
      var currentUrl = 0; // 获取当前删除的url

      if (file.response !== undefined) {
        // 是新增加的
        currentUrl = file.response.data[0].fileId;
      } else {
        // 是旧数据
        currentUrl = file.fileId;
      }

      this.files.forEach(function (item, index) {
        if (currentUrl === item.fileId) {
          _this3.files.splice(index, 1);

          return;
        }
      });
      this.fileList.forEach(function (item, index) {
        console.log(item);

        if (currentUrl === item.fileId) {
          _this3.fileList.splice(index, 1);

          return;
        }
      });
      console.log(this.files, this.fileList);
    },
    // 下载
    handleDownload: function handleDownload(url, name) {
      var link = document.createElement('a');
      link.style.display = 'none';
      link.href = url;
      link.setAttribute('download', name);
      document.body.appendChild(link);
      link.click();
    },
    // 判断上传的类型，方便数据库保存
    judgeFileType: function judgeFileType(str) {
      if (str === 'image/png' || str === 'image/jpeg' || str === 'image/jpg') {
        return 2;
      } else {
        return 1;
      }
    },
    handDispatch: function handDispatch() {
      var _this4 = this;

      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          if (_this4.keyValue > 0) {
            _this4.dispatchData.complaintId = _this4.keyValue;
            _this4.dispatchData.userId = _this4.dispatchData.repairUserList[1];
            fetchDispatch(_this4.dispatchData).then(function () {
              _this4.$emit('handCancle', 'dispatchRepair');

              _this4.Alert({
                alertType: 'add',
                message: '派工成功'
              });
            });
          }
        } else {
          _this4.Alert({
            alertType: 'valid'
          });
        }
      });
    },
    handCancle: function handCancle() {
      this.$emit('handCancle', 'dispatchRepair');
    }
  }
};